import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = auth
  const [viewAs, setViewAsState] = useState(() => localStorage.getItem("view_as") || null); // null | 'branch' | 'group'

  useEffect(() => {
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false));
  }, []);

  const setViewAs = (v) => {
    if (v) localStorage.setItem("view_as", v);
    else localStorage.removeItem("view_as");
    setViewAsState(v);
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setViewAs(null);
    setUser(data);
    return data;
  };
  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    setUser(data);
    return data;
  };
  const logout = async () => {
    await api.post("/auth/logout");
    setViewAs(null);
    setUser(false);
  };
  const setTier = async (tier) => {
    const { data } = await api.patch("/auth/tier", { tier });
    setUser((u) => ({ ...u, tier: data.tier }));
  };

  const canGroup = !!user && (user.role === "group_manager" || user.role === "manager");
  const isGroup = user ? (viewAs ? viewAs === "group" : user.role === "group_manager") : false;

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout, setTier, viewAs, setViewAs, canGroup, isGroup }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
